export default {
  methods: {
    formatterCarrierName(name) {
      const indexNumber = name.toString().indexOf('/');
      const result = name.toString().slice(indexNumber + 1, -4);
      return result;
    },
  }
};
